import angular from 'angular';
import application from 'application/application';

application

	.service('HttpPendingRequestsService', ['$q', ($q) => {

		var cancelPromises = [];

		function newTimeout() {

			var cancelPromise = $q.defer();

			cancelPromises.push(cancelPromise);

			return cancelPromise.promise;
		}

		function cancelAll() {

			angular.forEach(cancelPromises, (cancelPromise) => {
				cancelPromise.promise.canceled = true;
				cancelPromise.resolve();
			});

			cancelPromises.length = 0;

		}

		return {
			newTimeout: newTimeout,
			cancelAll: cancelAll
		};

	}]);
